import React from "react";
import * as Styled from "./CallBlock.styles";
import l10n from "../../../../localization";
import { Row } from "reactstrap";

export default function CallBlock() {
  return (
    <Styled.Card>
      <Styled.Header>{l10n.help.phoneContact}</Styled.Header>
      <Styled.Body>
        <Row>
          <Styled.BlockCol>
            <Styled.Title>{l10n.help.callBlock1}</Styled.Title>
            <Styled.link href="tel:+385(51)211906">
              Tel: (051) 211 906
            </Styled.link>
            <Styled.Text>Radno vrijeme: svaki dan od 0 do 24 sata</Styled.Text>
          </Styled.BlockCol>
          <Styled.BlockCol>
            <Styled.Title>{l10n.help.callBlock2}</Styled.Title>
            <Styled.link href="tel:+385(51)353222">
              Tel: (051) 353 222
            </Styled.link>
            <Styled.Text>Radno vrijeme: 7:30 - 15:30</Styled.Text>
          </Styled.BlockCol>
          <Styled.BlockCol>
            <Styled.Title>{l10n.help.callBlock3}</Styled.Title>
            <Styled.link href="tel:+385(51)353217">
              Tel: (051) 353 217
            </Styled.link>
            <br />
            <Styled.link href="tel:+385(51)353220">
              Tel: (051) 353 220
            </Styled.link>
          </Styled.BlockCol>
          <Styled.BlockCol>
            <Styled.Title>{l10n.help.callBlock4}</Styled.Title>
            <Styled.link href="tel:+385(51)353232">
              Tel: (051) 353 232
            </Styled.link>
            <br />
            <Styled.link href="tel:+385(51)353230">
              Tel: (051) 353 230
            </Styled.link>
          </Styled.BlockCol>
          <Styled.BlockCol>
            <Styled.Title>{l10n.help.callBlock5}</Styled.Title>
            <Styled.link href="mailto:registar@kdvik-rijeka.hr">
              registar@kdvik-rijeka.hr
            </Styled.link>
          </Styled.BlockCol>
        </Row>
      </Styled.Body>
    </Styled.Card>
  );
}
